module.exports = ".arrow-svg {\r\n    cursor: pointer;\r\n}"